<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              알림 발송
            </div>
          </section>
          <section class="section02">
            <div class="object01"></div>
            <div class="object02">
              <div class="form">
                <div class="select">
                  <div class="formSelect" ref="select01" @click="openSelect01">
                    <div class="formSelectList">
                      <input type="text" :value="findStatusName(status)" placeholder="발송 상태" readonly />
                    </div>
                    <div class="formSelectPopup select01">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input type="text" placeholder="검색어를 입력하세요." />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li v-for="statusInfo in statusList" :key="statusInfo.code">
                                    <label>
                                      <input type="radio" v-model="status" :value="statusInfo.code" v-on:change="search"/>
                                      <input type="checkbox" />
                                      <i></i>
                                      <span>{{ statusInfo.name }}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="select managementStatus">
                  <div class="formSelect" ref="select02" @click="openSelect02">
                    <div class="formSelectList">
                      <input type="text" :value="findAlarmMethodName(alarmMethod)" placeholder="알림 종류" readonly />
                    </div>
                    <div class="formSelectPopup select02">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input type="text" placeholder="검색어를 입력하세요." />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li v-for="alarmMethodInfo in alarmMethodList" :key="alarmMethodInfo.code">
                                    <label>
                                      <input type="radio" v-model="alarmMethod" :value="alarmMethodInfo.code" v-on:change="search"/>
                                      <input type="checkbox" />
                                      <i></i>
                                      <span>{{alarmMethodInfo.name}}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="select aplStatus">
                  <div class="formSelect" ref="select03">
                    <div class="formSelectList" @click="openSelect03">
                      <input type="text" v-model="select03Value" placeholder="대상" readonly />
                    </div>
                    <div class="formSelectPopup typeSearch typeMulti select03">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input type="text" placeholder="검색어를 입력하세요." v-model="searchValue" v-on:keyup="changeSearchValue" />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li>
                                    <label>
                                      <input type="radio" />
                                      <input type="checkbox" @click="selectAll" :checked="allSelected"/>
                                      <i></i>
                                      <span>전체선택</span>
                                    </label>
                                  </li>
                                  <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                                    <label>
                                      <input type="radio"/>
                                      <input type="checkbox" v-model="selectedClubList" name="selectedClubList" :value="clubInfo.ccode"/>
                                      <i></i>
                                      <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel" @click="cancelSelect03">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm" @click="confirmSelect03">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input">
                  <input type="text" v-model="contentSearch" placeholder="검색어를 입력하세요" @keyup.enter="search" />
                </div>
                <div class="search">
                  <button @click="search">
                    검색
                  </button>
                </div>
              </div>
            </div>
            <div class="object03">
              <button class="registration" @click="moveMenu('/SE203')">
                등록하기
              </button>
            </div>
          </section>
          <section class="section03 body dev_headerLine scroll-body">
            <!-- 데이터 없을때(Class) : none -->
            <div class="object01" :class="alarmCnt === 0 ? 'none' : ''">
              <div class="table thead">
                <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                <div class="fixed grid">
                  <div class="unit">
                    전체 <span>{{alarmCnt}}</span>건
                  </div>
                  <div class="contain">
                    <table>
                      <colgroup>
                        <col class="sendStatus" />
                        <col class="sendDate" />
                        <col class="reception" />
                        <col class="object" />
                        <col class="kind" />
                        <col class="registrationDate" />
                      </colgroup>
                      <thead>
                      <tr>
                        <th class="sendStatus">
                          <div class="item">
                            발송 상태
                          </div>
                        </th>
                        <th class="sendDate">
                          <div class="item">
                            발송 일시
                          </div>
                        </th>
                        <th class="reception">
                          <div class="item">
                            수신 인원
                          </div>
                        </th>
                        <th class="object">
                          <div class="item">
                            대상
                          </div>
                        </th>
                        <th class="kind">
                          <div class="item">
                            알림 종류
                          </div>
                        </th>
                        <th class="registrationDate">
                          <div class="item">
                            등록일
                          </div>
                        </th>
                      </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
              <div class="table tbody">
                <div class="contain">
                  <table>
                    <colgroup>
                      <col class="sendStatus" />
                      <col class="sendDate" />
                      <col class="reception" />
                      <col class="object" />
                      <col class="kind" />
                      <col class="registrationDate" />
                    </colgroup>
                    <tbody>
                    <tr v-for="alarmInfo in alarmList" :key="alarmInfo.alarm_id" @click="moveMenu('/SE202?alarm_id=' + alarmInfo.alarm_id)">
                      <td class="sendStatus">
                        {{ findStatusName(alarmInfo.status) }}
                      </td>
                      <td class="sendDate">
                         {{ alarmInfo.alarm_send_datetime }}
                      </td>
                      <td class="reception">
                        {{ alarmInfo.target_list ? `${alarmInfo.recept_cnt || 0} / ${alarmInfo.target_list}` : '미입력' }}
                      </td>
                      <td class="object">
                        {{ targetInfo(alarmInfo) }}
                      </td>
                      <td class="kind">
                        {{findAlarmMethodName(alarmInfo.alarm_method)}}
                      </td>
                      <td class="registrationDate">
                        {{ alarmInfo.isrt_dt.substring(0,10) }}
                      </td>
                    </tr>
                    </tbody>
                    <tbody class="none">
                    <tr>
                      <td colspan="8">
                        데이터가 없습니다.
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01">
              <!-- 이전 활성 : prevActive / 다음 활성 : nextActive -->
              <div class="paging" :class="pageClass">
                <div class="prev" @click="prevPage">
                  <div class="item">
                    이전
                  </div>
                </div>
                <ul class="number" v-for="index in pageArray" :key="index">
                  <!-- 활성 : active -->
                  <li :class="index == pageNo ? 'active': ''" @click="getPage(index)">
                    {{ index }}
                  </li>
                </ul>
                <div class="next" @click="nextPage">
                  <div class="item">
                    다음
                  </div>
                </div>
              </div>
            </div>
            <div class="object02" v-if="alarmList !== null && alarmCnt !== alarmList.length" @click="morePage">
              더보기
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {clubInfoService, settingService, userService} from '../../router'

export default {
  name: 'SE201',
  data () {
    return {
      contentSearch: '',
      status: '',
      statusList: [
        {name: '전체', code: 'all'},
        {name: '발송 예정', code: 'ready'},
        {name: '발송중', code: 'process'},
        {name: '발송 실패', code: 'fail'},
        {name: '발송 완료', code: 'complete'}
      ],
      alarmMethod: '',
      alarmMethodList: [
        {name: '전체', code: 'all'},
        {name: 'Email', code: 'email'},
        {name: 'SMS', code: 'sms'}
      ],
      orderTarget: 'club_name',
      orderValue: 'asc',
      searchValue: '',
      selectedClubList: [],
      currentClubList: [],
      pageNo: 1,
      pageIndex: 0,
      pageSize: 15,
      pageBufferRight: 0,
      pageBufferLeft: 0,
      pageBuffer: 5,
      alarmList: null,
      alarmCnt: 0,
      searchParams: {
        pageNo: 1,
        pageSize: 15,
        status: 'all',
        alarmMethod: 'all',
        selectedClubList: [],
        contentSearch: ''
      }
    }
  },
  created: function () {
    Promise.all([userService.getAll(), clubInfoService.getClubInfoList('active')]).then(response => {
      this.userInfo = response[0].data
      this.clubInfoList = response[1].data.clubInfoList
      this.selectClubInfoList = response[1].data.clubInfoList
    }).catch(error => {
      console.log('getClubInfoListByStatusActive.err.===>', error)
    })
  },
  mounted: function () {
    this.setData()
    window.addEventListener('resize', this.resizeEvt)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.resizeEvt)
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
      if (this.allSelected) this.searchParams.selectedClubList = []
      settingService.getAlarmList(this.searchParams.pageNo, this.searchParams.pageSize, this.searchParams.status, this.searchParams.alarmMethod, this.searchParams.selectedClubList.toString(), this.searchParams.contentSearch).then(response => {
        this.alarmCnt = response.data.totalCount
        this.alarmList = response.data.alarmList || []
      }).catch(error => {
        console.log('getAlarmList.err.===>', error)
      })
    },
    search: function () {
      this.pageNo = 1
      this.pageIndex = 0
      this.searchParams = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        status: this.status,
        alarmMethod: this.alarmMethod,
        selectedClubList: this.selectedClubList,
        contentSearch: this.contentSearch
      }
      this.setData()
    },
    findStatusName: function (status) {
      if (this.statusList.find(it => it.code === status) !== undefined) {
        return this.statusList.find(it => it.code === status).name
      } else {
        return ''
      }
    },
    findAlarmMethodName: function (method) {
      if (this.alarmMethodList.find(it => it.code === method) !== undefined) {
        return this.alarmMethodList.find(it => it.code === method).name
      } else {
        return ''
      }
    },
    selectAll: function () {
      if (this.allSelected) {
        this.selectedClubList = []
      } else {
        this.selectedClubList = this.clubInfoList.map(it => it.ccode)
      }
    },
    openSelect03: function () {
      if (document.querySelector('body.type-content.select03Active') !== null) {
        this.cancelSelect03()
      } else {
        this.closeSelectAll()
        document.querySelector('body.type-content').classList.add(`select03Active`)
        document.querySelector('body.type-content').classList.add('multiSelect')
      }
    },
    cancelSelect03: function () {
      this.selectedClubList = this.currentClubList
      this.closeSelectAll()
    },
    confirmSelect03: function () {
      this.currentClubList = this.selectedClubList
      this.closeSelectAll()
      this.search()
    },
    closeSelectAll: function () {
      document.querySelector('body.type-content').classList.remove(`select01Active`)
      document.querySelector('body.type-content').classList.remove(`select02Active`)
      document.querySelector('body.type-content').classList.remove(`select03Active`)
      document.querySelector('body.type-content').classList.remove(`select04Active`)
      document.querySelector('body.type-content').classList.remove(`multiSelect`)
      this.tooltipActive = false
      this.selectedClubList = this.currentClubList
    },
    getPage: function (index) {
      this.pageNo = index
      this.searchParams.pageNo = index
      this.setData()
    },
    morePage: function () {
      this.pageNo += 1
      this.searchParams.pageNo = this.pageNo
      settingService.getAlarmList(this.searchParams.pageNo, this.searchParams.pageSize, this.searchParams.status, this.searchParams.alarmMethod, this.searchParams.selectedClubList.toString(), this.searchParams.contentSearch).then(response => {
        this.alarmCnt = response.data.totalCount
        this.alarmList = this.alarmList.concat(response.data.alarmList)
      })
    },
    nextPage: function () {
      if (this.pageIndex >= this.pageIndexMax) return
      this.pageIndex++
      this.getPage(this.pageArray[0])
    },
    prevPage: function () {
      if (this.pageIndex <= 0) return
      this.pageIndex--
      this.getPage(this.pageArray[this.pageArray.length - 1])
    },
    resetSearchParams: function () {
      this.pageNo = 1
      this.pageIndex = 0
      this.status = ''
      this.alarmMethod = ''
      this.selectedClubList = []
      this.currentClubList = []
      this.contentSearch = ''
      this.searchParams = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        status: this.status,
        alarmMethod: this.alarmMethod,
        selectedClubList: this.selectedClubList,
        contentSearch: this.contentSearch
      }
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          this.resetSearchParams()
          this.setData()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          this.resetSearchParams()
          this.setData()
        }
      }
    },
    targetInfo: function (targetInfo) {
      if (targetInfo.target_all_yn) return '전체'
      if (targetInfo.target_list === null) return '대상없음'
      return `골프클럽(${targetInfo.target_list})`
    },
    alarmStatus: function (status, receptCnt, targetList) {
      let statusMsg = ''
      if (status === 'ready') {
        statusMsg = '발송 예정'
      } else if (status === 'complete' && targetList !== null && receptCnt === targetList) {
        statusMsg = '발송 완료'
      } else {
        statusMsg = '발송 실패'
      }
      return statusMsg
    }
  },
  computed: {
    pageArray: function () {
      if (this.alarmCnt <= 0) return [1]
      let pageMax = Math.floor((this.alarmCnt - 1) / this.pageSize) + 1
      let arr = []
      for (let i = 1; i <= this.pageBuffer; i++) {
        let j = this.pageIndex * this.pageBuffer + i
        if (j > pageMax) break
        arr.push(j)
      }
      return arr
    },
    pageIndexMax: function () {
      return Math.floor((this.alarmCnt - 1) / (this.pageSize * this.pageBuffer))
    },
    pageClass: function () {
      return {
        nextActive: this.pageIndex < this.pageIndexMax,
        prevActive: this.pageIndex > 0
      }
    },
    select03Value: function () {
      if (!this.selectedClubList.length) return ''
      if (this.selectedClubList.length === this.clubInfoList.length) return '전체'
      return `골프클럽(${this.selectedClubList.length})`
    },
    allSelected: function () {
      return this.selectedClubList.length === this.clubInfoList.length
    }
  },
  watch: {
    pageIndex: function (val) {
      this.pageIndex = val < 0 ? 0 : val > this.pageIndexMax ? this.pageIndexMax : val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/setting/SE201.vue